module.exports = {"TXTCLI_Remove":{"id":"TXTCLI_Remove","defaultMessage":"Fjern","track":"Remove"}}